var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.875 17.875C6.875 16.9899 7.17615 16.0945 7.91168 15.6021C8.79378 15.0114 9.85637 14.6667 11 14.6667C12.1436 14.6667 13.2062 15.0114 14.0883 15.6021C14.8239 16.0945 15.125 16.9899 15.125 17.875",
    stroke: "#423F5A",
    strokeWidth: 1.375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9999 12.375C12.2656 12.375 13.2916 11.349 13.2916 10.0834C13.2916 8.8177 12.2656 7.79169 10.9999 7.79169C9.73427 7.79169 8.70825 8.8177 8.70825 10.0834C8.70825 11.349 9.73427 12.375 10.9999 12.375Z",
    stroke: "#423F5A",
    strokeWidth: 1.375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0417 10.0833C17.0593 10.0833 18.0048 10.4288 18.7894 11.0205C19.4544 11.5221 19.7084 12.3705 19.7084 13.2035V13.2916",
    stroke: "#423F5A",
    strokeWidth: 1.375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0416 7.79167C17.0541 7.79167 17.8749 6.97086 17.8749 5.95833C17.8749 4.94581 17.0541 4.125 16.0416 4.125C15.0291 4.125 14.2083 4.94581 14.2083 5.95833C14.2083 6.97086 15.0291 7.79167 16.0416 7.79167Z",
    stroke: "#423F5A",
    strokeWidth: 1.375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.95841 10.0833C4.9408 10.0833 3.99534 10.4288 3.21076 11.0205C2.54572 11.5221 2.29175 12.3705 2.29175 13.2035V13.2916",
    stroke: "#423F5A",
    strokeWidth: 1.375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.95833 7.79167C6.97086 7.79167 7.79167 6.97086 7.79167 5.95833C7.79167 4.94581 6.97086 4.125 5.95833 4.125C4.94581 4.125 4.125 4.94581 4.125 5.95833C4.125 6.97086 4.94581 7.79167 5.95833 7.79167Z",
    stroke: "#423F5A",
    strokeWidth: 1.375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserGroup);
export default __webpack_public_path__ + "static/media/user-group.834de60319b13f20f2f462043b001beb.svg";
export { ForwardRef as ReactComponent };